import { render, staticRenderFns } from "./LayoutEmail.vue?vue&type=template&id=37ab869f&"
import script from "./LayoutEmail.vue?vue&type=script&lang=js&"
export * from "./LayoutEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports